import { queryKeys } from 'config/queryKeys'
import { ProductsRes } from 'features/products'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchProducts = (userId: string) => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const {
		data: products,
		isFetching: isProductsLoading,
		isSuccess: isProductsSuccess
	} = useQuery<ProductsRes>({
		queryKey: queryKeys.products.list(`owner_id=${userId}`),
		queryFn: () => axiosPrivate.get(`/products/?owner_id=${userId}`),
		enabled: !!auth.accessToken
	})

	return {
		products,
		isProductsLoading,
		isProductsSuccess
	}
}
